import { render, staticRenderFns } from "./MiniPaperControl.vue?vue&type=template&id=c47d089c&scoped=true&"
import script from "./MiniPaperControl.vue?vue&type=script&lang=js&"
export * from "./MiniPaperControl.vue?vue&type=script&lang=js&"
import style0 from "../bottomLeftControl.scss?vue&type=style&index=0&id=c47d089c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47d089c",
  null
  
)

export default component.exports